import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import Box from "../../../components/_styles/Box";
import { HeaderContainer } from "../Cohorts/Create";
import { InfoButtonIcon } from "../FollowUpList/Icons";
import { PageTitle, Card } from "../../../styles";
import Table from "../../../components/Table/Table";
import SearchField from "../SharedComponents/SearchField";
import { ReactComponent as SearchIconCustom } from "../../../assets/searchIconGrey.svg";
import { ReactComponent as EmptyStateImg } from "../../../assets/empty-state-search.svg";
import SmsCreationDialog, { TemplateButton } from "../Messages/SmsCreationDialog";
import DoubleDataCell from "../PatientList/LastScanCell";
import { EmptyState } from "../../../components/EmptyState/EmptyState";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteRecoCohort,
  deleteReportCohort,
  getReportCohorts,
  showAlert,
  toggleReportCohort,
} from "../../../actions/radminUploads";
import RemoveConfirmation from "./RemoveConfirmation";
import LoadMoreButton from "../../../components/LoadMoreButton";
import cioEvent from "../../../assets/cio_icon.svg";
import DescriptionChipGroups from "../RecommendationCohorts/DescriptionChipGroups";
import { parseQuery } from "../RecommendationCohorts/util";
import { CIOCampaignsIcon } from "../Messages/Icons";
import moment from "moment";
import { Col } from "react-bootstrap";

const SearchFieldContainer = styled.div`
  display: flex;
  flex: auto;
  justify-content: right;
  height: 38px;
  margin-right: 17px;
`;

export const Image = styled.img`
  width: 20px;
  margin-right: 7px;
  color: #000000;
  fill: #000000;
`;

const useStyles = makeStyles({
  label: {
    padding: "5px 0px",
    fontSize: "12px",
    fontWeight: "bold",
  },
  campaignButton: {
    backgroundColor: "#00AEEF",
    textTransform: "none",
    width: "8rem",
    height: "38px",
    color: "#FFFFFF",
    border: "2px solid #00AEEF",
    "&:hover": {
      backgroundColor: "transparent",
      color: "#00AEEF",
    },
  },
});

const DescriptionValue = styled.div`
  font-family: Roboto Condensed;
  font-style: normal;
  font-size: 14px;
  text-align: initial;
  color: #000000;
  margin: 0px;
  display:flex;
  gap:15px;
  flex-wrap:wrap;
`;


const SendCohortmessageButton = styled.span`
color: #00AEEF;
cursor:pointer;
white-space:nowrap;
`
const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 78px;
  height: 24px;
  padding: 0 12px;
  border-radius: 100px;
  color: #ffffff;
  font-size: 11px;
  font-weight: 600;
  font-family: Open Sans, sans-serif;
  background: ${({ active }) => (active ? "#64C67C" : "#A7A9AD")};
`;

const StyledButton = styled.button`
border: 2px solid ${({ active }) => (!active ? '#00AEEF' : '#B5B5B5')};
color: ${({ active }) => (!active ? '#00AEEF' : '#B5B5B5')};
background: ${({ active }) => (!active ? '#EFFBFF' : '#FFFFFF')};
min-width: 153px;
font-size: 14px;
font-weight: ${({ active }) => (!active ? 700 : 400)};
height: 26px;
cursor: pointer;
position: relative;

&:first-child {
  border-radius: 4px 0 0 4px;
  border-right:1px solid #00AEEF

}

&:last-child {
  border-radius: 0 4px 4px 0;
  border-left:1px solid  #00AEEF;
}
`

const columns = [
  {
    key: "title",
    name: "Name",
    width: "20%",
    align: "left",
  },
  {
    key: "trigger_cio_event",
    name: "Messaging Campaign",
    width: "20%",
    displayCell: (cellValue, rowData) => (
        cellValue && <CIOCampaignsIcon />
    ),
    align: "left",
  },
  {
    key: "computed_status_criteria",
    name: "Report Tracking Name",
    width: "20%",
    align: "left",
    displayCell: (cellValue, rowData) => (
     cellValue?.name ?? '-'
  ),
  },
  {
    key: "computed_status_criteria",
    name: "Status(es) Included",
    width: "20%",
    align: "left",
    displayCell: (cellValue, rowData) => (
     cellValue?.computed_status_filter?.map(itm=>itm.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase()))?.join(', ') ?? '-'
  ),
  },
  
  {
    key: "description",
    name: "Description",
    align: "left",
     displayCell: (cellValue, rowData) => {
        const { parents, operators } = parseQuery(cellValue);
      return ( 
        <DescriptionValue>
        <DescriptionChipGroups parents={parents} operators={operators} />
        </DescriptionValue>
      ) 
    }
  },
  {
    key: "active",
    name: "Status",
    width: "12%",
    displayCell: (cellValue) => (
      <StatusBadge active={!!cellValue}>
        {cellValue ? "Active" : "Inactive"}
      </StatusBadge>
    ),
  },
];



const CohortList = ({
  activeTab,
  titleForSearch,
  setTitleForSearch,
  page,
  setPage,
}) => {
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  // const [page, setPage] = useState(1);
  const [removeDialogOpen, setRemoveDialogOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [openMessage, setOpenMessage] = useState(false);
  const [cohortId, setCohortId] = useState();
  
  // const [titleForSearch, setTitleForSearch] = useState("");
  const [isLoadingDeleteCohort, setIsLoadingDeleteCohort] = useState(false);
  const hasReportSearchEventsEnabled =  useSelector((state) => state.auth.user.provider.report_search_event);
  const hasBulkMessageEnabled =  useSelector((state) => state.auth.user.provider.bulk_msg_from_report_search);

  const permission = useSelector((state) => state.auth.user.permission_level);
  const rolePermissions = useSelector((state) => state.auth.user.permissions);
  const createPermission = rolePermissions
    ?.find((itm) => itm.name === "Cohorts")
    ?.permissions.find(
      (itm) => itm.codename === "add_cohorts"
    )?.is_authorized;
  const deletePermission = rolePermissions
    ?.find((itm) => itm.name === "Cohorts")
    ?.permissions.find(
      (itm) => itm.codename === "delete_cohorts"
    )?.is_authorized;
  const updatePermission = rolePermissions
    .find((itm) => itm.name === "Cohorts")
    ?.permissions.find(
      (itm) => itm.codename === "change_cohorts"
    )?.is_authorized;


  useEffect(() => {
    if (activeTab === "reports") {
      const query = new URLSearchParams(history.location.search);
      let title = query.get("title");
      if (title) {
        dispatch(getReportCohorts(page, title));
      } else {
        dispatch(getReportCohorts(page, titleForSearch));
      }
    }
  }, []);

  useEffect(() => {
    if (activeTab === "reports") {
      const query = new URLSearchParams(history.location.search);
      let title = query.get("title");
      if (title) {
        setTitleForSearch(title);
        dispatch(getReportCohorts(null, title));
      }
    }
  }, []);

  const cohortReportList = useSelector(
    (state) => state.radAdmin?.cohortReports
  );

  const dialogHandler = (data) => {
    setRemoveDialogOpen(!removeDialogOpen);
    setSelectedId(data.id);
    window.analytics.track("Cohort-Report-Delete-Button-Click");
  };

  const deleteCohortHandler = () => {
    setIsLoadingDeleteCohort(true);
    dispatch(deleteReportCohort(selectedId)).then(() => {
      setIsLoadingDeleteCohort(false);
      setRemoveDialogOpen(false);
    });
  };

  const createCohortReportHandler = () => {
    history.push("/auth/radAdmin/messages/cohorts-report/create");
    window.analytics.track("Cohort-Report-Create-Button-Click");
  };

  const onLoadMore = () => {
    dispatch(getReportCohorts(page + 1, titleForSearch));
    setPage(page + 1);
  };

  const viewReportsHandler = (data) => {
    window.analytics.track("Cohort-Reports-View-Button-Click");
    history.push(`/auth/radAdmin/followUp/reports/cohorts/details/${data.id}`, {
      data: data,
    });
  };

  const handleToggleChange = async (rowData, active) => {
    const success = await dispatch(
      toggleReportCohort(rowData.id, active)
    );
  
    if (success) {
      dispatch(getReportCohorts(page, titleForSearch));
    }
  };

  const finalColumns = hasReportSearchEventsEnabled? columns : columns.filter(itm=>itm.key !== 'trigger_cio_event')


  const openMessageHandler = (state, id) => {
    window.analytics.track('Report-Cohort-List-Send-Message-Button-Click');
    setOpenMessage(state);
    setCohortId(id);
  };

  return (
    <Box>
      <RemoveConfirmation
        content="Are you sure you want to remove this cohort?"
        openDialog={removeDialogOpen}
        dialogHandler={dialogHandler}
        isLoading={isLoadingDeleteCohort}
        deleteHandler={deleteCohortHandler}
        heading={"Remove Cohort"}
        removeHeader={"Yes, Remove Cohort"}
      />
      {/* <HeaderContainer>
        <PageTitle>Cohorts</PageTitle>
        <SearchFieldContainer>
          <SearchField
            placeholder="Search Cohort Title"
            value={titleForSearch}
            onChangeHandle={(e) => {
              setTitleForSearch(e.target.value);
              history.push({
                search: `?title=${e.target.value}`,
              });
            }}
            onReset={() => {
              if (titleForSearch) {
                dispatch(getReportCohorts(1, ""));
                setPage(1);
                setTitleForSearch("");
                history.push({
                  search: `?title=`,
                });
              }
            }}
            onSearchEnter={() => {
              setPage(1);
              dispatch(getReportCohorts(null, titleForSearch));
            }}
            styles={{
              marginRight: 0,
              marginBottom: 0,
              width: "318px",
              position: "relative",
            }}
            placeholderStyles={{
              color: "#828282",
              fontWeight: 400,
              fontSize: "16px",
              fontFamily: "Open Sans",
              marginLeft: "32px",
            }}
            inputStyles={{
              background: "#FFFFFF",
              border: "1px solid #D2D3D7",
              textAlign: "left",
              paddingLeft: "20px",
              height: "38px",
            }}
            searchIconStyles={{
              marginLeft: "12px",
            }}
            clearIconStyle={{
              right: 20,
              marginLeft: 0,
            }}
            SearchIconCustom={<SearchIconCustom />}
          />
        </SearchFieldContainer>
        <div>
          <Button
            classes={{ label: classes.label, root: classes.campaignButton }}
            onClick={createCohortReportHandler}
          >
            Create Cohort
          </Button>
        </div>
      </HeaderContainer> */}
      {/* <CohortTab /> */}
      <div style={{width: '94.2vw'}}>
      <Card>
        <div style={{overflowX:'auto'}}>
        <Table
          rows={cohortReportList?.data && cohortReportList?.data}
          columns={ finalColumns.concat(
            {
              key: "1",
              name: "",
              displayCell: (cellValue, rowData) => ( 
                hasBulkMessageEnabled &&
                <SendCohortmessageButton   onClick={(e) =>{
                  e.stopPropagation()
                  if((rowData?.message_sent_status === 'in_queue' || rowData?.message_sent_status ==='in_progress')){
                   dispatch(
                        showAlert(
                          "danger",
                          "Error",
                          `Message is already in queue. Please try again after some time.`
                        )
                      );
                  }else if((rowData?.message_sent_status === 'completed' || rowData?.message_sent_status ==='errored') &&  moment().diff(moment(rowData?.last_message_sent_at), 'hours') < 6
                ){
                 dispatch(showAlert(
                    "danger",
                    "Error",
                    `Please wait ${Math.ceil(6 - moment().diff(moment(rowData?.last_message_sent_at), 'hours'))} hours before sending a new message.`
                  ))
                  }
                  else{
                    openMessageHandler(true, rowData?.id)
                  }
                } }>Send Message to Cohort</SendCohortmessageButton>
              ),
              // width: "20px",
            },
            {
              key: "2",
              name: "",
              displayCell: (cellValue, rowData) => (
                <TemplateButton
                  clickHandler={() => viewReportsHandler(rowData)}
                  border={true}
                  color={"#00AEEF"}
                  outlinedBr={"#00AEEF"}
                  title="View Reports"
                  width
                  icon={<InfoButtonIcon />}
                />
              ),
              // width: "20px",
            },
            {
              key: "3",
              name: "",
              displayCell: (cellValue, rowData) => (
                <Col>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <StyledButton
                      active={rowData.active}
                      onClick={() => handleToggleChange(rowData, false)}
                    >
                      Disable
                    </StyledButton>
            
                    <StyledButton
                      active={!rowData.active}
                      onClick={() => handleToggleChange(rowData, true)}
                    >
                      Enable
                    </StyledButton>
                  </div>
                </Col>
              ),
              width: "20px",
            },
            {
              key: "4",
              name: "",
              displayCell: (cellValue, rowData) => (
                <DoubleDataCell
                  mainInfo={"edit"}
                  
              
 EditRecoHandler={() => {
                    if ((permission && updatePermission) || !permission) {
                      history.push(
                        "/auth/radAdmin/followUp/reports/cohorts/create",
                        { data: rowData }
                      );
                      window.analytics.track(
                        "Cohort-Report-Edit-Button-Click"
                      );
                    } else {
                      dispatch(
                        showAlert(
                          "danger",
                          "Error",
                          `You don't have permission to update reports cohort`
                        )
                      );
                    }
                  }}
                   RemoveRecoHandler={() => {
                                      if ((permission && deletePermission) || !permission) {
                                        dialogHandler(rowData);
                                      } else {
                                        dispatch(
                                          showAlert(
                                            "danger",
                                            "Error",
                                            `You don't have permission to delete reports cohort`
                                          )
                                        );
                                      }
                                    }}
                />
              ),
              // width: "20px",
            }
          )}
          isLoadingRows={
            cohortReportList?.isLoading &&
            (cohortReportList?.data.length === 0 ||
              cohortReportList?.data.length === 1)
          }
          getRowsAction={(pageNumber) =>
            getReportCohorts(pageNumber, titleForSearch)
          }
          noDataRender={() => (
            <EmptyState title={"No Results"} img={() => <EmptyStateImg />}>
              Sorry, there are no results
            </EmptyState>
          )}
        />
        {cohortReportList?.data && cohortReportList?.data.length !== 0 && (
          <LoadMoreButton
            title="Load more"
            isLoading={
              cohortReportList?.isLoading &&
              cohortReportList?.totalItems !== cohortReportList?.data.length
            }
            handleClick={onLoadMore}
            isDisabled={
              cohortReportList?.totalItems === cohortReportList?.data.length
            }
          />
        )}
        </div>
      </Card>
      </div>

      {
              openMessage && <SmsCreationDialog
              openMessage={openMessage}
              openMessageHandler={openMessageHandler}
              patientDetails={{}}
              fromCohorts={true}
              cohortId={cohortId}
              viewPermissionGroup="Cohorts"
              viewPermissionName="cohorts"
            />
             }
            
    </Box>
  );
};

export default CohortList;
